// extracted by css-extract-rspack-plugin
var _1 = "oiEWQgd15ZMfQgjYw6Xw1w--";
var _2 = "_72l-7oEsmtq9XFSC5bR56Q-- oiEWQgd15ZMfQgjYw6Xw1w--";
var _3 = "_9VondavaEmkC-tk7ZSZ0lA-- oiEWQgd15ZMfQgjYw6Xw1w--";
export { _1 as "box", _2 as "boxFullWidth", _3 as "boxWide" }
